import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import { SearchUserDto } from '@studyportals/campaign-management-api-interface';
import store from '@/store';

export default class RightsUserOverviewCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusRights();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public rightsUsers = computed((): SearchUserDto[] => {
		return store.getters.rightsUsers();
	});

	public removeRightsUser(user: SearchUserDto): void {
		store.mutations.removeRightsUser(user);
	}
}
